(ns frontend.actions.fundraising-opportunity
  (:require
   [frontend.conn :as conn]
   [promesa.core :as p]
   [frontend.analytics :as analytics]
   [frontend.logging :as logging]))

;; NOTE
;; Should be one-to-one mapping with domain/oppo
;; No other tasks should be performed here
;; Should only be required in `events` files
;; Function signatures should always be
;; [data on-success! on-error!]
;; Keep it Simple and Silly

(defn *->disable
  [data on-success! on-error!]
  (-> (conn/sendp! :fundraising-opportunity/disable
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->put-on-hold
  [data on-success! on-error!]
  (-> (conn/sendp! :fundraising-opportunity/put-on-hold
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->lost!
  [data on-success! on-error!]
  (-> (conn/sendp! :fundraising-opportunity/lost
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->won!
  [data on-success! on-error!]
  (-> (conn/sendp! :fundraising-opportunity/won
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->resurrect!
  [data on-success! on-error!]
  (-> (conn/sendp! :fundraising-opportunity/resurrect
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

